import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || '79619002008',
    bg: searchParams.get('bg') || '1',
    phoneNumber,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    qrCode: searchParams.get('qrCode'),
    sizeQR: searchParams.get('sizeQR') || '20',
    paddingQR: searchParams.get('paddingQR') || '0',
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    titleFontSize: searchParams.get('titleFontSize') || '4.8',
    questionFontSize: searchParams.get('questionFontSize') || '4',
    answerFontSize: searchParams.get('answerFontSize') || '3.6',
    varNumFontSize: searchParams.get('varNumFontSize') || '5',

    fio: searchParams.get('ФИО') || '5',

    // ws
    domain: searchParams.get('domain') || 'develop.feed',
    wsMaxRetries: Number(searchParams.get('wsMaxRetries')) || 3,
    wsRetriesDelay: Number(searchParams.get('wsRetriesDelay')) || 500,
    wsReconnectDelay: Number(searchParams.get('wsReconnectDelay')) || 180,
    wsPort: Number(searchParams.get('wsPort')) || 8001,
    wsActive: Number(searchParams.get('wsActive') || 1),
  };
};
